<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  <p-fieldset legend="Gas Composition %">
    <form [formGroup]="form.formGroup">

      <p-toolbar>
        <ng-template #start></ng-template>
        <ng-template #end>
          <div class="flex items-center">
            <svg-icon
              src="../../assets/icons/reset-default-24x24.svg"
              class="w-[25px] h-[25px] tree-icon cursor-pointer"
              (click)="applyDefaults()"
              title="Apply Defaults">
            </svg-icon>
          </div>
        </ng-template>
      </p-toolbar>


      <div class="flex flex-wrap">
        <!-- Left Column -->
        <div class="w-full md:w-1/3 p-2 space-y-2">

          <div class="flex flex-col">
            <label for="co2" class="mb-1">CO<span class="text-xss align-sub">2</span></label>
            <app-validated-number-input
              [id]="'co2'"
              [control]="control('co2')"
              [value]="control('co2').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('co2', $event)"
              [unit]="'%'"
              [unitPrecisionOverrides]="{ '%': 6 }"
            ></app-validated-number-input>
          </div>

          <div class="flex flex-col">
            <label>
              C1 =&nbsp;
              <span>CH</span><span class="text-xs align-sub">4</span>
            </label>
            <app-validated-number-input
              [id]="'c1'"
              [control]="control('c1')"
              [value]="control('c1').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('c1', $event)"
              [unit]="'%'"
              [unitPrecisionOverrides]="{ '%': 6 }"
            ></app-validated-number-input>
          </div>

          <div class="flex flex-col">
            <label for="nc4">NC<span class="text-xs align-sub">4</span></label>
            <app-validated-number-input
              [id]="'nC4'"
              [control]="control('nC4')"
              [value]="control('nC4').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('nC4', $event)"
              [unit]="'%'"
              [unitPrecisionOverrides]="{ '%': 6 }"
            ></app-validated-number-input>
          </div>

          <div class="flex flex-col">
            <label for="iC5">IC<span class="text-xs align-sub">5</span></label>
            <app-validated-number-input
              [id]="'iC5'"
              [control]="control('iC5')"
              [value]="control('iC5').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('iC5', $event)"
              [unit]="'%'"
              [unitPrecisionOverrides]="{ '%': 6 }"
            ></app-validated-number-input>
          </div>
        </div>

        <!-- Center Column -->
        <div class="w-full md:w-1/3 p-2 space-y-2">

          <div class="flex flex-col">
            <label for="h2S" class="mb-1">H<span class="text-xs align-sub">2</span>S</label>
            <app-validated-number-input
              [id]="'h2S'"
              [control]="control('h2S')"
              [value]="control('h2S').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('h2S', $event)"
              [unit]="'%'"
              [unitPrecisionOverrides]="{ '%': 6 }"
            ></app-validated-number-input>
          </div>

          <div class="flex flex-col">
            <label for="c2">C<span class="text-xs align-sub">2</span></label>
            <app-validated-number-input
              [id]="'c2'"
              [control]="control('c2')"
              [value]="control('c2').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('c2', $event)"
              [unit]="'%'"
              [unitPrecisionOverrides]="{ '%': 6 }"
            ></app-validated-number-input>
          </div>

          <div class="flex flex-col">
            <label for="iC4">i-C<span class="text-xs align-sub">4</span></label>
            <app-validated-number-input
              [id]="'iC4'"
              [control]="control('iC4')"
              [value]="control('iC4').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('iC4', $event)"
              [unit]="'%'"
              [unitPrecisionOverrides]="{ '%': 6 }"
            ></app-validated-number-input>
          </div>

          <div class="flex flex-col">
            <label for="nC6">NC<span class="text-xs align-sub">6</span></label>
            <app-validated-number-input
              [id]="'nC6'"
              [control]="control('nC6')"
              [value]="control('nC6').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('nC6', $event)"
              [unit]="'%'"
              [unitPrecisionOverrides]="{ '%': 6 }"
            ></app-validated-number-input>
          </div>
          </div>

        <!-- Right Column -->
        <div class="w-full md:w-1/3 p-2 space-y-2">

          <div class="flex flex-col">
            <label for="n2" class="mb-1">N<span class="text-xs align-sub">2</span></label>
            <app-validated-number-input
              [id]="'n2'"
              [control]="control('n2')"
              [value]="control('n2').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('n2', $event)"
              [unit]="'%'"
              [unitPrecisionOverrides]="{ '%': 6 }"
            ></app-validated-number-input>
          </div>

          <div class="flex flex-col">
            <label for="c3">C<span class="text-xs align-sub">3</span></label>
            <app-validated-number-input
              [id]="'c3'"
              [control]="control('c3')"
              [value]="control('c3').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('c3', $event)"
              [unit]="'%'"
              [unitPrecisionOverrides]="{ '%': 6 }"
            ></app-validated-number-input>
          </div>

          <div class="flex flex-col">
            <label for="nC5">NC<span class="text-xs align-sub">5</span></label>
            <app-validated-number-input
              [id]="'nC5'"
              [control]="control('nC5')"
              [value]="control('nC5').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('nC5', $event)"
              [unit]="'%'"
              [unitPrecisionOverrides]="{ '%': 6 }"
            ></app-validated-number-input>
          </div>

          <div class="flex flex-col">
            <label for="c7C10">C<span class="text-xs align-sub">7</span> to C<span class="text-xs align-sub">10</span></label>
              <app-validated-number-input
                [class.pointer-events-none]="true"
                [class.opacity-50]="true"
                [id]="'c7C10'"
                [control]="control('c7C10')"
                [value]="control('c7C10').value"
                [validation]="{ min: 0, max: 100 }"
                [unit]="'%'"
                [unitPrecisionOverrides]="{ '%': 6 }"
              ></app-validated-number-input>
              @if (form.formGroup.controls.c7C10.invalid) {
                <p class="validation-error">Total Gas Composition % must be equal to 100%</p>
              }
          </div>
        </div>
      </div>

      <div class="flex flex-col p-2 space-y-2">
        <!-- Field for Average Molecular Weight C7 to C10 -->
        <div class="flex flex-col">
          <label for="averageMolWeightC7ToC10">
            Avg. Mol Mass of C<span class="text-xs align-sub">7</span> to C<span class="text-xs align-sub">10</span>
          </label>
            <app-validated-number-input
              [id]="'averageMolWeightC7ToC10'"
              [control]="control('averageMolWeightC7ToC10')"
              [value]="control('averageMolWeightC7ToC10').value"
              [validation]="{ min: 0, max: 100000000 }"
              (onChange)="calculateGasGravity('averageMolWeightC7ToC10', $event)"
              [unit]="'g/mol'"
              [unitPrecisionOverrides]="{ 'g/mol': 3 }"
            ></app-validated-number-input>
        </div>
        <!-- Field for Gas Gravity -->
        <div class="flex flex-col">
          <label for="gasGravity">Gas Gravity</label>
          <input id="gasGravity" pInputText [disabled]="true" value="{{ totalMolWeight }}" class="w-full" />
        </div>
      </div>

    </form>
  </p-fieldset>
</app-tool-loader>